export const HEATMAP_VALUE_FORMATS = { NUMBER: 'number', CURRENCY: 'currency'};

const COMPACT_VALUE_THRESHOLD = 99999;
const normalizeCompactSuffix = value => value.replace(/[KMBT]/g, match => match.toLowerCase());

export const formatHeatmapDisplayValue = (value, options = {}) => {
  const number = Number(value);

  if (!Number.isFinite(number)) return '--';

  const {
    style = HEATMAP_VALUE_FORMATS.NUMBER,
    compact = false,
    currency = 'USD',
    minimumFractionDigits,
    maximumFractionDigits,
  } = options;

  const shouldCompact = compact && Math.abs(number) >= COMPACT_VALUE_THRESHOLD;

  if (shouldCompact) {
    return normalizeCompactSuffix(new Intl.NumberFormat('en-US', {
      style: style === HEATMAP_VALUE_FORMATS.CURRENCY ? 'currency' : 'decimal',
      currency,
      notation: 'compact',
      compactDisplay: 'short',
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
    }).format(number));
  }

  if (style === HEATMAP_VALUE_FORMATS.CURRENCY) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
      minimumFractionDigits: minimumFractionDigits ?? 0,
      maximumFractionDigits: maximumFractionDigits ?? 0,
    }).format(number);
  }

  return new Intl.NumberFormat('en-US', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
  }).format(number);
};
